import { Outlet } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import CTAFloating from '@/components/base/CTAFloating';
import ScrollToTop from '@/components/base/ScrollToTop';
import ScrollRestoration from '@/components/base/ScrollRestoration';
import ContactFormSection from '@/components/feature/ContactFormSection';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <ScrollRestoration />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <ContactFormSection />
      <Footer />
      <CTAFloating />
      <ScrollToTop />
    </div>
  );
}